'use client';

import api from '@lib/api';
import ROUTES from '@lib/constants/routes';
import { HEADER_PROFILE_30915 } from '@lib/flags';
import { handleOpenMenu, handleOpenMenuMobile } from '@lib/store/slices/ComponentsSlice';
import { flatsLocalStorageSelector } from '@lib/store/slices/FavoriteFlatSlice';
import { useViewport } from '@lib/tools/hooks/useViewport';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DropDownFlats from './components/DropDownFlats';
import DropDownStandartBlock from './components/DropDownStandartBlock';
import DropDownVisual from './components/DropDownVisual';
import style from './HeaderButtons.module.scss';
import { useIconWrapperStyle } from './hooks/useHeaderColorScheme ';
import { useMatchedRoute } from './hooks/useMatchedRoute';
const HeaderButtons = ({
  headerColorScheme,
  visual
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const flatfavorites = useSelector(flatsLocalStorageSelector);
  const dispatch = useDispatch();
  const {
    isMobile,
    viewport
  } = useViewport();
  const headBarIconWrapperStyle = useIconWrapperStyle(headerColorScheme);
  const pathname = usePathname();
  const match = useMatchedRoute();
  const deviceMobileMenuClose = useCallback(() => {
    !isMobile ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false));
  }, [viewport]);
  const filteredFavorites = flatfavorites?.filter(fl => fl.status !== 'reserve');
  const favoritesCount = isMounted ? filteredFavorites?.length : 0;
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const dropDownSelect = () => {
    if (['visual', 'floor', 'house', 'bulk'].includes(match)) {
      return <DropDownVisual onClick={deviceMobileMenuClose} />;
    }
    if (pathname.includes(ROUTES.flats.list)) {
      return <DropDownFlats onClick={deviceMobileMenuClose} />;
    }
    return <DropDownStandartBlock onClick={deviceMobileMenuClose} />;
  };
  return <div className={style.headerBar__select}>
      {HEADER_PROFILE_30915 && <Link className={style.link__profile} href={api.urlProfile} target='_blank'>
          <div className={headBarIconWrapperStyle} role='button' tabIndex='0'>
            <div className={style.headerBar__profile}>
              <svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M6.97912 7.52941C9.04971 7.52941 10.7438 5.83529 10.7438 3.76471C10.7438 1.69412 9.04971 0 6.97912 0C4.90853 0 3.21441 1.69412 3.21441 3.76471C3.21441 5.83529 4.90853 7.52941 6.97912 7.52941ZM6.97912 8.94118C3.49677 8.94118 0.485002 11.4824 0.0144135 14.9647C-0.0797041 15.4353 0.296767 16 0.861472 16H0.95559H13.0027C13.5674 16 13.9438 15.6235 13.9438 15.0588V14.9647C13.4732 11.4824 10.4615 8.94118 6.97912 8.94118Z' fill='#1C1C1C' />
              </svg>
            </div>
          </div>
        </Link>}
      <Link className={style.link} href={ROUTES.favorites.root}>
        <div onClick={deviceMobileMenuClose} className={headBarIconWrapperStyle} role='button' tabIndex='0'>
          <div className={style.headerBar__heart}>
            <svg width='16' height='15' viewBox='0 0 16 15' fill='none'>
              <path fillRule='evenodd' clipRule='evenodd' d='M3.61848 0.503437C2.11498 0.72228 1.06589 1.42978 0.467229 2.62856C0.0191351 3.52581 -0.126021 4.83965 0.116573 5.8025C0.351854 6.7364 0.915854 7.76431 1.78567 8.84447C2.85923 10.1776 4.51707 11.7232 6.38182 13.1295C6.69789 13.3678 7.82501 14.1695 7.9527 14.2467C7.99748 14.2738 8.22589 14.1202 9.0537 13.506C11.3382 11.8112 13.2994 9.95959 14.4987 8.3655C15.6288 6.86344 16.0956 5.60615 15.9628 4.42256C15.7071 2.14462 13.8386 0.457061 11.5693 0.454593C10.4036 0.453311 9.34001 0.889968 8.4912 1.71831C8.36229 1.84412 8.20057 2.01831 8.13182 2.10544C8.06307 2.19256 7.99979 2.26384 7.9912 2.26384C7.9826 2.26384 7.91932 2.19256 7.85057 2.10544C7.30913 1.41934 6.42448 0.835905 5.56804 0.60003C5.04748 0.456655 4.22117 0.415718 3.61848 0.503437Z' fill='#1C1C1C' />
            </svg>
          </div>
          {favoritesCount !== 0 && <div className={style.headerBar__iconwrapper__favor}>{filteredFavorites?.length}</div>}
        </div>
      </Link>
      {!visual && dropDownSelect()}
    </div>;
};
export default HeaderButtons;